var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGotv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.119,
    height: 15.834,
    viewBox: "0 0 85.119 15.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gotv-nigeria-logo-vector",
    transform: "translate(126.3 -224.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M252.836,230.129H251.02a1.008,1.008,0,0,0-.624.312l-6.881,9.009a.266.266,0,0,1-.454-.014l-6.356-9a.855.855,0,0,0-.681-.312h-12.2a.381.381,0,0,1-.383-.383v-2.979a.763.763,0,0,0-.766-.766h-5.306a.763.763,0,0,0-.766.766v11.577c.085,1.419,1.107,3.008,3.916,3.008h23.566a1.108,1.108,0,0,0,.837-.355l8.073-10.613c.043,0,.213-.255-.156-.255m-16.614,9.619H225.34c-1.518,0-1.873-.426-1.873-1.6V232.1a.386.386,0,0,1,.355-.383h6.328a.876.876,0,0,1,.568.284l5.675,7.449c.1.17.043.3-.17.3",
    transform: "translate(-294.249 -1.63)",
    fill: "#008b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M-89.042,224.114h0l-.78-.014H-91v.014c-7.732.227-10.116,3.859-10.428,7.165h-9.889a.376.376,0,0,0-.355.383v.965a.386.386,0,0,0,.355.383h3.618a.416.416,0,0,1,.4.4h0v2.114h0v1.036c-.128,1.078-1.121,1.461-3.391,1.476-5.845-.142-8.953-2.625-8.953-6.016h0c0-3.49,3.277-6.03,9.449-6.03h5.789a.376.376,0,0,0,.355-.383V224.7a.386.386,0,0,0-.355-.383H-111.7c-11.663,0-14.6,4.2-14.6,7.676h0c0,3.49,2.937,7.676,14.6,7.676h4.384c2.3,0,3.944-.17,5.25-.922a2.34,2.34,0,0,0,1.263-1.7h0v-.014c0-.057.014-.114.014-.17v-.582c.043-.284.17-.3.2-.3.114-.014.2.014.369.17h0c1.39,2.015,4.171,3.618,9.222,3.774v.014h1.958v-.014c8.328-.241,10.457-4.427,10.457-7.931h0c0-3.448-2.128-7.633-10.457-7.874m-.908,14.259c-2.625.028-4.8-2.8-4.824-6.285s2.071-6.356,4.7-6.37,4.781,2.8,4.824,6.285-2.071,6.342-4.7,6.37",
    fill: "#e30613"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotv);
export default __webpack_public_path__ + "static/media/gotv.68d72e5b4d8febf4729f1e1ebe709075.svg";
export { ForwardRef as ReactComponent };